import React from 'react';
import { useTranslate } from 'react-translate-plus';
import styled from 'styled-components';

import { ConfigurationState } from '../../interfaces/ConfigurationState';

interface Props {
  state: ConfigurationState;
  changedBy?: string;
}

export const ConfigurationStateText: React.FC<Props> = ({ state, changedBy }) => {
  const t = useTranslate('ConfigurationStateText');
  return (
    <StyledState state={state}>
      {t(state)} {changedBy}
    </StyledState>
  );
};

const StyledState = styled.span<{ state: ConfigurationState }>`
  ${({ state, theme }) => `
  color: ${theme.colors[`STATE_${state}`] || theme.colors.STATE_DRAFT};
`}
`;
